<div class="pt-2 pb-3">
    <div *ngFor="let tagItem of userCallsList" class="tag-btn">
        <div class="d-flex flex-row align-items-center justify-content-between">{{ tagItem.callQueue.name }} <i class="pi pi-times-circle ml-2" (click)="confirmCallsDelete(tagItem)"></i></div>
    </div>
</div>
<p-dropdown [options]="callOptions" [(ngModel)]="selectedCall" [filter]="true" optionLabel="name" placeholder="Select Call Queue" styleClass="w-100" (onChange)="confirmAddCall($event)"></p-dropdown>

<p-confirmDialog styleClass="dark-glass-dialog" key="leadCallQueues" [style]="{ width: '50vw' }" [baseZIndex]="10000"></p-confirmDialog>
